import { CompanyManagementService } from '@/client'
import { useGlobalStore } from '@/stores/globalStore'

export async function executeLeaveDemo() {
  const globalStore = useGlobalStore()
  await CompanyManagementService.removeDemoDataApiV1CompanyRemoveDemoDataPost(
    {}
  )

  // Close popup
  globalStore.currentPopup = null

  // reload page
  window.location.reload()
}
